export enum CarriesAppReduxActions {
    CARRIES_APP_SET_PACKET_PAGINATION = 'CARRIES_APP_SET_PACKET_PAGINATION',
    CARRIES_APP_TABID = 'CARRIES_APP_TABID',
    CARRIES_APP_SET_ZOOM_LEFT_DOCUMENT = 'CARRIES_APP_SET_ZOOM_LEFT_DOCUMENT',
    CARRIES_APP_SET_ZOOM_RIGHT_DOCUMENT = 'CARRIES_APP_SET_ZOOM_RIGHT_DOCUMENT',
    CARRIES_APP_SET_SINGLE_ZOOM_LEFT_DOCUMENT = 'CARRIES_APP_SET_SINGLE_ZOOM_LEFT_DOCUMENT',
    CARRIES_APP_SET_SINGLE_ZOOM_RIGHT_DOCUMENT = 'CARRIES_APP_SET_SINGLE_ZOOM_RIGHT_DOCUMENT',
    CARRIES_APP_SET_SOLICITOR_VIEWER_PACKETID = 'CARRIES_APP_SET_SOLICITOR_VIEWER_PACKETID',
    CARRIES_APP_SET_SOLICITOR_VIEWER_DUPLICATION = 'CARRIES_APP_SET_SOLICITOR_VIEWER_DUPLICATION',
    CARRIES_APP_SET_VISIBILITY_STATE = 'CARRIES_APP_SET_VISIBILITY_STATE',
    CARRIES_APP_PAGE_LEAVE_STATE = 'CARRIES_APP_PAGE_LEAVE_STATE',
    CARRIES_LOCATION_CHANGE = '@@router/LOCATION_CHANGE',
}

export const setPacketPaginationNumber = (payload: any): any => ({
    type: CarriesAppReduxActions.CARRIES_APP_SET_PACKET_PAGINATION,
    payload,
});
export const setZoomLeftDocument = (payload: any): any => ({
    type: CarriesAppReduxActions.CARRIES_APP_SET_ZOOM_LEFT_DOCUMENT,
    payload,
});
export const setZoomRightDocument = (payload: any): any => ({
    type: CarriesAppReduxActions.CARRIES_APP_SET_ZOOM_RIGHT_DOCUMENT,
    payload,
});
export const setZoomSingleLeftDocument = (payload: any): any => ({
    type: CarriesAppReduxActions.CARRIES_APP_SET_SINGLE_ZOOM_LEFT_DOCUMENT,
    payload,
});

export const setZoomSingleRightDocument = (payload: any): any => ({
    type: CarriesAppReduxActions.CARRIES_APP_SET_SINGLE_ZOOM_RIGHT_DOCUMENT,
    payload,
});

export const setSolicitorPacketId = (payload: any): any => ({
    type: CarriesAppReduxActions.CARRIES_APP_SET_SOLICITOR_VIEWER_PACKETID,
    payload,
});

export const setSolicitorDuplication = (payload: any): any => ({
    type: CarriesAppReduxActions.CARRIES_APP_SET_SOLICITOR_VIEWER_DUPLICATION,
    payload,
});

export const SetCarryVisibilityState = (payload: any): any => ({
    type: CarriesAppReduxActions.CARRIES_APP_SET_VISIBILITY_STATE,
    payload,
});

const SetBroadcastTabId = (payload: any): any => ({
    type: CarriesAppReduxActions.CARRIES_APP_TABID,
    payload,
});

const setPageLeave = (payload: any): any => ({
    type: CarriesAppReduxActions.CARRIES_APP_PAGE_LEAVE_STATE,
    payload,
});

export const CarryAppActions = {
    setSolicitorPacketId,
    setPacketPaginationNumber,
    setSolicitorDuplication,
    setZoomLeftDocument,
    setZoomRightDocument,
    setZoomSingleLeftDocument,
    setZoomSingleRightDocument,
    SetBroadcastTabId,
    SetCarryVisibilityState,
    setPageLeave,
};
